import { render } from "./previewModel.vue?vue&type=template&id=c1634e8a"
import script from "./previewModel.vue?vue&type=script&lang=js"
export * from "./previewModel.vue?vue&type=script&lang=js"

import "./previewModel.vue?vue&type=style&index=0&id=c1634e8a&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__